import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class BillPaymentService {

  constructor(private http: HttpClient) { }

  saveBillPayment(payload: any) {
    return this.http.post(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILL_PAYMENTS, payload)
      .pipe(catchError(errorHandl));
  }

  getBillPayments(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILL_PAYMENTS, { params })
      .pipe(catchError(errorHandl));
  }

  getBillPaymentById(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILL_PAYMENTS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  voidPayment(id: any) {
    return this.http.post(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILL_PAYMENTS + `/${id}/void`, {})
      .pipe(catchError(errorHandl));
  }

  deletePayment(id: any) {
    return this.http.delete(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILL_PAYMENTS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  syncBillPayment(id: any, queryParams: any = {}) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.BILL_PAYMENTS + `/${id}/${urls.SYNC}`, { params })
      .pipe(catchError(errorHandl));
  }
}
